import React, { createContext, useState, useContext } from 'react';
import { getFromAPI } from '../../../../Utils/utils';

// Create Context
export const LeaveContext = createContext();

// Custom hook to use the GSTContext
export const useLeave = () => useContext(LeaveContext);

// Create a Context Provider component
export const FestivalLeaveProvider = ({ children }) => {
    const [getFestivalLeave, setgetFestivalLeave] = useState([]);

    const fetchFestivalLeave = async () => {
        try {
            const response = await getFromAPI('FtsFestivalLeave/');
            setgetFestivalLeave(response);
        } catch (error) {
            console.error('Error fetching GST data:', error);
        }
    };

    return (
        <LeaveContext.Provider value={{ getFestivalLeave, fetchFestivalLeave }}>
            {children}
        </LeaveContext.Provider>
    );
};
